import store from '@/store'
import { GlobalHelpers } from '../mainExports'
export default {
  getSubscriptions() {
    const connection = GlobalHelpers.getConnection()
    return connection.session.subscriptions
  },
  getSubscriptionsFromTopic() {
    const allSubscriptions = store.getters['subscriptionState/allSubscriptions']
    return Object.values(allSubscriptions.things.updated)
  },
  unsubscribeAll(subscriptions) {
    return new Promise(async resolve => {
      const connection = GlobalHelpers.getConnection()
      const allPromisesUnsubscribed = []
      for (const sub of subscriptions) {
        const subId = sub.id
        allPromisesUnsubscribed.push(connection.session.unsubscribe(sub))
        store.dispatch('subscriptionState/removeSubscriptionFromState', subId)
      }
      const res = await Promise.allSettled(allPromisesUnsubscribed)
      const promisesUnsubscribedRetry = []
      res.forEach(({ status }, idx) => {
        if (status === 'rejected')
          promisesUnsubscribedRetry.push(connection.session(subscriptions[idx]))
      })
      promisesUnsubscribedRetry.length &&
        (await Promise.all(promisesUnsubscribedRetry))
      resolve()
    })
  }
}
